
import axios from "./axios";

export const updateUserProfileData = async (userData) => {
  try {
    const response = await axios.post(
      'auth/profile/update',
      userData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
}

export const updateUserProfile = async (
  bcPic,
  profilePic,
  fullName,
  bio,
  website,
  location
) => {
  try {
    const response = await axios.put(
      "/api/user/update/profile",
      {
        bcPic,
        profilePic,
        fullName,
        bio,
        website,
        location,
      },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};
export const fetchUserProfile = async (username) => {
  try {
    const response = await axios.post(
      "/api/user/get/profile",
      {
        username,
      },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchProfileInformations = async () => {
  try {
    const response = await axios.get('get_user_topics', {
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
}

export const fetchUserInformations = async () => {
  try {
    const response = await axios.get('get_user_informations', {
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
}
export const followUser = async (userId) => {
  try {
    const response = await axios.post(`/api/user/${userId}/follow`, null, {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};
export const unfollowUser = async (userId) => {
  try {
    const response = await axios.post(`/api/user/${userId}/unfollow`, null, {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const getUserFollowers = async (userId, offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/${userId}/followers`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const getUserFollowings = async (userId, offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/${userId}/followings`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchTheUserTweets = async (userid, offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/${userid}/tweets`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchTheUserLikedTweets = async (userid, offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/${userid}/tweets/liked`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchTheUserMediaTweets = async (userid, offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/${userid}/tweets/media`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchUserFeedTweets = async (userid, offset = 0, signal) => {
  try {
    const response = await axios.post(
      `/api/user/${userid}/tweets/feed`,
      { offset },
      {
        signal: signal,
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchSuggstedUsers = async () => {
  try {
    const response = await axios.post(`/api/user/users_suggestions`, null, {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const searchUsers = async (text, offset = 1, query) => {
  try {
    let url = `/user_topic?title=${text}&page=${offset}`;
    if (query) {
      url = `/user_topic?title=${text}&page=${offset}&${query}`
    }
    const response = await axios.get(
      url,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const deleteNotification = async (notificationid) => {
  try {
    const response = axios.delete(`/notifications/delete/${notificationid}`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });

    return response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export const getNotifications = async () => {
  try {
    const response = await axios.get(
      `/notifications`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const getMentionsNotifications = async (offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/notifications/mentions`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchBookmarks = async (offset = 0) => {
  try {
    const response = await axios.post(
      `/api/user/bookmarks`,
      { offset },
      {
        headers: {
          authorization: localStorage.getItem("token"),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};

export const fetchNews = async () => {
  try {
    const response = await axios.get(
      `user_topics?topic_level_id=2&topic_category_id=1`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
};


export const fetchStates = async () => {
  try {
    const response = await axios.get(
      `states`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
};

export const fetchLocalities = async (state_id) => {
  try {
    let url = `localities`
    if (state_id) {
      url = `localities?state_id=${state_id}`;
    }
    const response = await axios.get(
      url,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
};